import { getCollegePlanLimit } from './validate.helpers';
/**
 * Validates the fund min/max for college contribute
 */
export function validateCollegeContributeFund({
  fund,
  collegeFundsTowardsPlanMax,
}) {
  delete fund.priorYearError; // Doesn't exist for college
  delete fund.collegePlanMaxError;

  const { formattedEntityNames, productType } = fund;

  const balanceByBeneficiaryAndType =
    collegeFundsTowardsPlanMax[formattedEntityNames][productType];

  // Scenario: Maximum plan value
  const planTotal = balanceByBeneficiaryAndType; // pending + shopping cart + existing balance
  const { max: planLimit = 0 } = getCollegePlanLimit(productType) || { max: 0 };
  if (planTotal > planLimit) {
    fund.collegePlanMaxError = `Plan max is ${planLimit}`;
  }

  // Value used by editor to determine which max limit to show
  // i.e. - if daily max is 400k, plan max is 500k, and user has contributed 300k,
  // show plan max because 200k remaining contributions available < 400k daily max
  fund.collegeAvailableContributionsRemaining = planLimit - planTotal;

  // Scenario: Maximum Daily Contribution
  // Already coverered - This is verified by the logic in validate buy fund

  // Validate the fund min/max
  // Scenario: Minimum and maximum contribution to an individual fund
  // Already covered by currentYear limits in fund payload

  return fund;
}
